export const KEY_STORE = {
  TOKEN: 'accessToken',
};
